import { FC } from 'react'
import * as m from 'motion/react-m'
import { MotionNodeAnimationOptions, stagger } from 'motion'
import raffleApi from '../../lib/raffle/api'
import { AnimatePresence } from 'motion/react'

export const TopQuestionsList: FC<{
  searchPageUrl: string
  raffleSearchUid: string
}> = ({ raffleSearchUid, searchPageUrl }) => {
  const { data, isLoading } = raffleApi.useQuery('get', '/v2/top_questions', {
    params: {
      query: {
        uid: raffleSearchUid,
      },
    },
  })

  const getSearchUrlWithQuestion = (question: string): string => {
    const url = new URL(searchPageUrl, window.location.origin)
    url.searchParams.set('q', question.trim())
    return url.toString()
  }

  const listAnimation: MotionNodeAnimationOptions = {
    initial: 'hidden',
    animate: 'visible',
    transition: {
      delayChildren: stagger(0.12, {
        startDelay: 0.58, // Start after the dialog animation.
      }),
    },
  }

  const listItemAnimation: MotionNodeAnimationOptions = {
    variants: {
      hidden: { opacity: 0, scale: 0.9 },
      visible: {
        opacity: 1,
        scale: 1,
        transition: {
          opacity: { duration: 0.2 },
          scale: {
            duration: 0.3,
            type: 'spring',
            bounce: 0.5,
          },
        },
      },
    },
  }

  const listItemSkeletonAnimation: MotionNodeAnimationOptions = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
  }

  return (
    <section aria-busy={isLoading} aria-labelledby="raffle-top-questions-title">
      <h3
        id="raffle-top-questions-title"
        className="raffle-top-questions__title"
      >
        Populære spørgsmål:
      </h3>
      <AnimatePresence>
        {data?.questions && (
          <m.ul
            className="raffle-top-questions__list typo__dark-text"
            {...listAnimation}
          >
            {data.questions.map(
              ({ question }, i) =>
                question && (
                  <m.li
                    key={i}
                    {...listItemAnimation}
                    whileHover={{ scale: 1.02 }}
                  >
                    <a
                      className="raffle-top-questions__list-item"
                      href={getSearchUrlWithQuestion(question)}
                    >
                      {question}
                    </a>
                  </m.li>
                ),
            )}
          </m.ul>
        )}
        {isLoading && (
          <div className="raffle-top-questions__list" aria-hidden>
            {/* Top questions are defined in Raffle and has a limit of 5. */}
            {Array.from({ length: 5 }, (_, i) => (
              <m.div
                key={i}
                className="skeleton w-40 h-heading"
                {...listItemSkeletonAnimation}
              ></m.div>
            ))}
          </div>
        )}
      </AnimatePresence>
    </section>
  )
}
